import { Page } from '@web/components/page';
import { DefaultProps, withServerProps } from '@web/library/with-server-props';
import { ShopProductScreen, ShopProductScreenProps } from 'shared/screens/shop/shop-product';

type ShopProductPageProps = ShopProductScreenProps & DefaultProps;

export default function ShopProductPage(props: ShopProductPageProps) {
  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(props.product?.name)
          .setDescription(props.product?.summary)
          .setImage(props.product?.media_assets[0]?.url)
          .forProduct(props.product, {
            shopSettings: props.defaultProps.shopData.settings,
          })
      }
    >
      <ShopProductScreen key={props.product.id} {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShopProductScreen.pageBuilder);
